const actionTypes = { UPDATE_SMARTCHAT_STATE: 'UPDATE_SMARTCHAT_STATE' };

module.exports = actionTypes;
